import { z, ZodType } from 'zod';

export type Player = {
	id: number;
	name: string;
	balance: number;
	inputDevice: string;
	order: number;
	isConnected: boolean;
};

export const playerSchema: ZodType<Player> = z.object({
	id: z.number(),
	name: z.string(),
	balance: z.number(),
	inputDevice: z.string(),
	order: z.number(),
	isConnected: z.boolean(),
});
